import {Breadcrumbs, ErrorPopup, Title} from '@management-ui/core';
import {Box} from '@mui/material';
import React from 'react';
import InboxStatus from '../../../../components/MessageStatus';
import routes from '../../../../routes';

const Wrapper = ({title, message, loading, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading}>
        {message ? (
          <Box display="flex" flex={1} justifyContent="flex-end"><InboxStatus message={message}/></Box>
        ) : null}
      </Title>
      {children}
      <ErrorPopup errors={['message']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Inbox', link: routes.inbox.index}
];

export default Wrapper;
